import React from 'react'
import { backendGetRequest } from '../../../../../../helpers/callBackend';
import { downloadPDF } from '../../../../../../helpers/downloadPDF';
import { message } from 'antd';

const DownloadStatement = (props) => {

    const downloadLatestUnitStatement = (bankAccountId) => {
        backendGetRequest("/api/bank-account/statement/", {
          params: { bank_account_id: bankAccountId },
        }).then((res) => {
          const statements = res?.data?.data;
          const statement = statements[0];
    
          if (statement) {
            backendGetRequest(
              "/api/bank-account/statement/",
              {
                params: {
                  bank_account_id: bankAccountId,
                  statement_id: statement.id,
                },
              },
              "loading"
            ).then((res) => {
                const d = res?.data
                downloadPDF(
                    d,
                    `statement-${props.record.account.bank?.name
                      .toLowerCase()
                      .replace(/ /g, "-")}.pdf`
                  );
            })
          } else {
            message.error("No statements available");
          }
        });
    };

    const downloadStatement = () => {
        const bankId = props.record.id
        if (props.record.account.source === "UN") {
          downloadLatestUnitStatement(bankId);
        } else {
          backendGetRequest(
            "/api/bank-account/statement/",
            {
              params: {
                bank_account_id: bankId,
                statement_id: 1,
              },
            },
            "loading"
          ).then((res) => {
            const d = res?.data;
            downloadPDF(d, `statement.pdf`);
          })
        }
    };

  return (
    <>
       {props.record.account.api_connection_status_live &&
        props.record.account.has_statements && (
            <a onClick={downloadStatement}>
                <span>Download Statement</span>
            </a>
        ) 
        }
    </>
  )
}

export default DownloadStatement